import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DEFAULT_LOCALE_ID, normalizeLocale } from '@/i18n/localeCatalog';

export const useDashboardLocaleStore = create(
  persist(
    (set) => ({
      locale: DEFAULT_LOCALE_ID,
      setLocale: (locale) => set({ locale: normalizeLocale(locale) }),
    }),
    {
      name: 'eduquiz-dashboard-locale',
      partialize: (s) => ({ locale: s.locale }),
      merge: (persistedState, currentState) => ({
        ...currentState,
        ...(persistedState || {}),
        locale: normalizeLocale(
          persistedState && 'locale' in persistedState ? persistedState.locale : currentState.locale,
        ),
      }),
    },
  ),
);
